module.exports = __webpack_public_path__ + "img/drh5_title_jp.704c6904.png";